import { createContext } from 'react';

export type TenantRouteCapabilityMap = Record<string, boolean>;
export type TenantModuleCapabilityMap = Record<string, boolean>;

export interface TenantFeaturesContextType {
  routes: TenantRouteCapabilityMap;
  modules: TenantModuleCapabilityMap;
  /** True when spatial_connect or spatial_uwb CCI module is enabled. */
  hasSpatialModule: boolean;
  isRouteEnabled: (routeKey: string) => boolean;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Stable React context instance (separate module so Vite HMR does not recreate
 * the context when TenantFeaturesContext.tsx hot-reloads).
 */
export const TenantFeaturesContext = createContext<TenantFeaturesContextType | undefined>(undefined);
